<template>
  <v-btn
    id="export-button"
    small
    color="primary"
    class="ml-2 elevation-0"
    :loading="loading"
    :disabled="disabled"
    @click="click"
  >
    <v-icon :size="isMobile ? 18 : 18" class="export-button-icon">
      mdi-cloud-download-outline
    </v-icon>
    <span v-if="showTextExportCsv" class="export-button-text ml-2">
      {{ $t('views.common.exportButton.exportCsv') }}
    </span>
  </v-btn>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    click: {
      type: Function,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showTextExportCsv: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['user']),
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
}
</script>

<style lang="scss">
#export-button {
  margin-top: 1px;
  // height: 33px;
  .export-button-text {
    text-transform: none;
    font-size: 12px;
  }
}
.export-button-icon {
  margin-bottom: 2px;
}
</style>
